/** Pride of snow (fx 'snowpride'): a rune circle and a ring of snow round the caster. */
import { registerFx } from './registry';

registerFx('snowpride', (host) => ({
  skill: ({ src, sx, sy }) => {
    host.fx.push({ type: 'sigil', x: sx, y: sy, t: 0, life: 0.8, r: 18, col: '230,240,255' });
    for (let k = 0; k < 10; k++) {
      const a = (k / 10) * Math.PI * 2;
      host.parts.push({
        x: sx + Math.cos(a) * 14,
        y: sy - 20 * host.tall(src) + Math.sin(a) * 7,
        vx: -Math.sin(a) * 30,
        vy: -20,
        g: 0,
        t: 0,
        life: 0.6,
        c: '#ffffff',
      });
    }
    host.sfx.charge();
  },
}));
